<template>
  <v-chip
    :label="label"
    :size="small ? 'small' : 'default'"
    v-bind="$attrs"
  >
    <slot />
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'CommonChip',

  props: {
    label: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
  }
});
</script>
